import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { Box, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link as LinkRRD, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoDataFound from "../../common/NoDataFound";
import LoadingUI from "../../common/LoadingUI";
import { postbackLogAction } from "../../redux/toolkit/postback/postbackLog";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { DatePicker } from "@mui/x-date-pickers";
import SnackUI from "../../common/SnackUI";
import axios from "axios";
import { render } from "@testing-library/react";
import LabelText from "../../common/LabelText";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { clearPostBackAction } from "../../redux/toolkit/postback/clearPostBack";

// import EditIcon from '@mui/icons-material/Edit'

function List() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);

  const postbackLogSelector = useSelector((state) => state.postbackLog);
  const {
    status,
    data,
    loading: listLoading,
    total,
    message,
  } = postbackLogSelector;

  const clearPostBack = useSelector((state) => state.clearPostBack);

  console.log("clearPostBack", clearPostBack);

  // const {
  //   status: clearStatus,
  //   message: clearMessage,
  // } = clearPostBack;

  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const [puserId, setPuserId] = useState("");
  const [state, setState] = useState(false);

  const [catMenu, setCatMenu] = useState(false);
  const [anchorCatMenu, setAnchorCatMenu] = useState();
  const [ativeFilter, setActiveFilter] = useState(false);
  const [isClearAllPostBack, setIsClearAllPostBack] = useState(false);

  const [selectedData, setSelectedData] = useState([]);

  console.log("selectedData =============>", selectedData);

  const dateWiseUser = () => {
    dispatch(
      postbackLogAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        userId: puserId,
      })
    );
    setState(true);
    setPuserId("");
  };

  const searchHandler = () => {
    let searchStatus = dispatch(
      postbackLogAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        userId: puserId,
        status: 0,
      })
    );
    setState(true);
  };

  const handleFailedAndSuccess = (val) => {
    setCatMenu(false);
    if (val === 2) {
      setIsClearAllPostBack(true);
    } else {
      setIsClearAllPostBack(false);
    }
    let searchStatus = dispatch(
      postbackLogAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        userId: puserId,
        status: val,
      })
    );
    setState(true);
    setActiveFilter(false);
  };

  useEffect(() => {
    dispatch(
      postbackLogAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        userId: puserId,
        status: 0,
      })
    );
    setState(true);
    setPuserId("");
  }, [dispatch, pageState.page, pageState.pageSize]);

  const handleResendPostback = async (data) => {
    let res = await dispatch(clearPostBackAction(data));
    // console.log("searchStatus", searchStatus);
    setErrorMessage(res?.payload?.message);
    setAlertOpen(true);
  };

  const AppColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "user_id",
      headerName: "P_User_Id",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "app_id",
      headerName: "App Id",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "publisher_payout",
      headerName: "Publisher Payout (USD)",
      flex: 1,
      minWidth: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {Number(params?.row?.publisher_payout).toFixed(4)}
          </Typography>
        );
      },
    },
    {
      field: "user_payout",
      headerName: "User Payout (USD)",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {Number(params?.row?.user_payout).toFixed(4)}
          </Typography>
        );
      },
    },
    {
      field: "trans_id",
      headerName: "Trans Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "url",
      headerName: "Url",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            <div
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                lineHeight: 1.4,
                width: "100%",
              }}
            >
              {params?.row?.url}
            </div>
          </Typography>
        );
      },
    },
    {
      field: "apiStatusCode",
      headerName: "Api Status Code",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "resentPostback",
      headerName: "Resend Postback",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      // hide: !
      renderCell: (params) => {
        return (
          <Button
            sx={{
              textTransform: "none",
              background:
                " linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
            }}
            variant="contained"
            onClick={() => {
              let data = {
                app_id: params?.row?.app_id,
                user_id: params?.row?.user_id, // this is p_user_id
                status: 1,
                trans_id: params?.row?.trans_id,
                publisher_payout: params?.row?.publisher_payout,
                user_payout: params?.row?.user_payout,
                offer_id: params?.row?.offer_id,
                bonus_amount: params?.row?.bonus_amount,
                postback_url: params?.row?.url,
              };
              handleResendPostback(data);
            }}
            // onClick={() => {
            //   let data = {
            //     app_id: params?.row?.app_id,
            //     user_id: params?.row?.user_id, // this is p_user_id
            //     status: params?.row?.status,
            //     trans_id: params?.row?.trans_id,
            //     publisher_payout: params?.row?.publisher_payout,
            //     user_payout: params?.row?.user_payout,
            //     offer_id: params?.row?.offer_id,
            //     bonus_amount: params?.row?.bonus_amount,
            //     postback_url: params?.row?.url,
            //   };
            //   axios
            //     .post(params?.row?.url, data)
            //     .then((res) => {
            //       console.log("res", res);
            //     })
            //     .catch((err) => {
            //       console.log("error=======>", err);
            //       if (err?.response?.status === 400) {
            //         setErrorMessage("Bad Request");
            //         setAlertOpen(true);
            //       }
            //     });
            // }}
          >
            Resend
          </Button>
        );
      },
    },

    {
      field: "created_at",
      headerName: "Created",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      // hide: !
      renderCell: (params) => {
        return (
          <Typography>
            {moment(params?.row?.created_at).format("DD-MM-YYYY hh:mm:ss A")}
          </Typography>
        );
      },
    },
  ];

  return (
    <>
      {/* <Typography sx={{ my: 1, fontWeight: "bold" }} variant="h6">
        PostBack Log
      </Typography>
      <Stack
        direction="row"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Grid xs={6}>
          <LabelText text="Search By P_User Id" />
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Paper
                elevation={0}
                component="form"
                sx={{
                  border: "1px solid rgba(217, 217, 217, 1)",
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: 400,
                  backgroundColor: "transparent",
                  height: "40px",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search By P_User Id"
                  inputProps={{ "aria-label": "search By P_User Id" }}
                  onChange={(e) => setPuserId(e.target.value)}
                />
                <IconButton
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                >
                  <SearchIcon onClick={searchHandler} />
                </IconButton>
              </Paper>
            </Stack>
          </Stack>
        </Grid>

        <Stack direction="row" spacing={2}>
          <Grid xs={6}>
            <LabelText text="Start Date" />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, startDate: newValue });
                }}
                renderInput={(params) => <TextField size="small" {...params} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid xs={6}>
            <LabelText text="End Date" />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, endDate: newValue });
                }}
                renderInput={(params) => <TextField size="small" {...params} />}
              />
            </LocalizationProvider>
          </Grid>

          {date.startDate && date.endDate && (
            <Button
              variant="contained"
              style={{ backgroundColor: "#0C6A96" }}
              onClick={dateWiseUser}
            >
              find data
            </Button>
          )}
        </Stack>
      </Stack> */}

      <Stack
        direction="row"
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography sx={{ my: 1, fontWeight: "bold" }} variant="h6">
          PostBack Log
        </Typography>

        <Stack direction="row" sx={{ width: "fit-content" }}>
          {isClearAllPostBack && (
            <Button
              variant="contained"
              sx={{
                // backgroundColor: "#0C6A96",
                backgroundColor: "#000",
                "&:hover": {
                  backgroundColor: "#000",
                },
                width: "fit-content",
                marginRight: "10px",
              }}
              // onClick={dateWiseUser}
            >
              Clear All
            </Button>
          )}

          <IconButton
            onClick={(event) => {
              setCatMenu(true);
              setAnchorCatMenu(event.currentTarget);
            }}
          >
            <FilterAltIcon color="#071D45" />
          </IconButton>

          <Menu
            open={catMenu}
            onClose={() => setCatMenu(false)}
            anchorEl={anchorCatMenu}
          >
            <MenuItem
              selected={!ativeFilter}
              onClick={() => {
                handleFailedAndSuccess(1);
              }}
            >
              Sucess
            </MenuItem>

            <MenuItem
              selected={ativeFilter}
              onClick={() => {
                handleFailedAndSuccess(2);
              }}
            >
              Failed
            </MenuItem>
          </Menu>
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ width: "100%" }}
      >
        {/* Search Box */}
        <Stack sx={{ width: { xs: "100%", sm: "40%" } }} spacing={1}>
          <LabelText text="Search By P_User Id" />
          <Paper
            elevation={0}
            component="form"
            sx={{
              border: "1px solid rgba(217, 217, 217, 1)",
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: { xs: "100%", sm: 400 },
              backgroundColor: "transparent",
              height: "40px",
              marginTop: "0px !important",
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search By P_User Id"
              inputProps={{ "aria-label": "search By P_User Id" }}
              onChange={(e) => setPuserId(e.target.value)}
            />
            <IconButton
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
              onClick={searchHandler}
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Stack>

        {/* Date Range + Button */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ width: { xs: "100%", sm: "60%" } }}
          alignItems={{ xs: "stretch", sm: "flex-end" }}
        >
          <Box sx={{ width: "35%" }}>
            <LabelText text="Start Date" />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) =>
                  setDate({ ...date, startDate: newValue })
                }
                renderInput={(params) => (
                  <TextField
                    size="small"
                    fullWidth
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: "Start Date", // force it inside inputProps
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>

          <Box sx={{ width: "35%" }}>
            <LabelText text="End Date" />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => setDate({ ...date, endDate: newValue })}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    fullWidth
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: "End Date", // force it inside inputProps
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>

          {date.startDate && date.endDate && (
            <Button
              variant="contained"
              sx={{
                // backgroundColor: "#0C6A96",
                backgroundColor: "#000",
                "&:hover": {
                  backgroundColor: "#000",
                },
                width: { xs: "100%", sm: "20%" },
                mt: { xs: 1, sm: 0 },
              }}
              onClick={dateWiseUser}
            >
              Find Data
            </Button>
          )}
        </Stack>
      </Stack>

      <Paper
        sx={{
          marginTop: 2,
          bgcolor: "#fff",
          "& .super-app-theme--header": {
            background: "rgba(254, 206, 113, 0.16)",
            color: "#000",
            borderBottom: " 1px solid #000",
            fontFamily: "Open Sans",
            fontSize: "13px",
          },
        }}
        elevation={0}
      >
        <DataGrid
          sx={{
            border: " 1px solid #000",
            "& .MuiDataGrid-row:hover": {
              background: "rgba(254, 206, 113, 0.16)",
              cursor: "pointer",
            },
          }}
          getRowHeight={({ densityFactor }) => {
            return 70 * densityFactor;
          }}
          autoHeight
          rows={data}
          columns={AppColumns}
          getRowId={(row) => row._id}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          pagination
          rowsPerPageOptions={[25, 50, 100]}
          disableColumnSelector
          loading={listLoading ? <LoadingUI /> : false}
          components={{
            NoRowsOverlay: () => <NoDataFound />,
            // Toolbar: GridToolbar,
          }}
          rowCount={total}
          paginationModel={setPageState}
          page={pageState.page}
          pageSize={pageState.pageSize}
          paginationMode="server"
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...old, page: newPage }));
          }}
          onPageSizeChange={(newPageSize) =>
            setPageState((old) => ({ ...old, pageSize: newPageSize }))
          }
        />
      </Paper>

      {/* <Paper
        sx={{
          marginTop: 2,
          bgcolor: "#fff",
          "& .super-app-theme--header": {
            background: "rgba(254, 206, 113, 0.16)",
            color: "#000",
            borderBottom: " 1px solid #000",
            fontFamily: "Open Sans",
            fontSize: "13px",
          },
        }}
        elevation={0}
      >
        <DataGrid
          sx={{
            border: " 1px solid #000",
            "& .MuiDataGrid-row:hover": {
              background: "rgba(254, 206, 113, 0.16)",
              cursor: "pointer",
            },
          }}
          getRowHeight={({ densityFactor }) => {
            return 70 * densityFactor;
          }}
          autoHeight
          rows={data}
          columns={AppColumns}
          getRowId={(row) => row._id}
          // disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          pagination
          rowsPerPageOptions={[25, 50, 100]}
          disableColumnSelector
          loading={listLoading ? <LoadingUI /> : false}
          components={{
            NoRowsOverlay: () => <NoDataFound />,
          }}


          // Checkbox selection props
          checkboxSelection
          rowSelectionModel={selectedIds}
          onEditRowsModelChange={(e) => console.log("row change------->", e)}
          onRowSelectionModelChange={(newSelection , event) => {
            console.log("Selection event fired:", newSelection , event);
            setSelectedIds(newSelection);
          }}
onRowClick={(params , e , f) => {
            console.log("params", params , e ,f);
          }}

          rowCount={total}
          paginationModel={pageState} // Changed from setPageState to pageState
          page={pageState.page}
          pageSize={pageState.pageSize}
          paginationMode="server"
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...old, page: newPage }));
          }}
          onPageSizeChange={(newPageSize) =>
            setPageState((old) => ({ ...old, pageSize: newPageSize }))
          }
        />
      </Paper> */}

      <SnackUI
        state={state}
        setState={setState}
        status={status}
        message={message}
      />
      {errorMessage && (
        <Snackbar
          open={alertOpen}
          autoHideDuration={3000}
          onClose={() => setAlertOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center", zIndex: 9999 }}
          sx={{ zIndex: 99999999999 }}
        >
          <Alert
            onClose={() => setAlertOpen(false)}
            severity="warning"
            sx={{ width: "100%", zIndex: 99999999999 }}
            // sx={{ width: "100%" }}
          >
            {errorMessage}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default List;
